import React from 'react';
import { Star } from 'lucide-react';
import { PetStats } from '../training/cards/PetStats';
import type { UserPet } from '../../types/pets';

interface PetGridProps {
  pets: UserPet[];
}

export function PetGrid({ pets }: PetGridProps) {
  const rarityColors = {
    common: 'text-gray-400',
    uncommon: 'text-green-400',
    rare: 'text-blue-400',
    epic: 'text-purple-400',
    legendary: 'text-yellow-400'
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {pets.map((pet) => (
        <div key={pet.id} className="bg-gray-800 rounded-lg p-6 space-y-4">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-bold text-white">{pet.name}</h3>
            <Star className={`w-5 h-5 ${rarityColors[pet.rarity]}`} />
          </div>

          <img
            src={pet.imageUrl}
            alt={pet.name}
            className="w-full h-48 object-cover rounded-lg"
          />

          <div className="space-y-2">
            <div className="flex justify-between items-center text-sm">
              <span className="text-gray-400 capitalize">
                {pet.type}
              </span>
              <span className="text-yellow-400">
                Level {pet.level}
              </span>
            </div>

            <div className="w-full h-2 bg-gray-700 rounded-full overflow-hidden">
              <div
                className="h-full bg-gradient-to-r from-yellow-600 to-amber-500"
                style={{ 
                  width: `${(pet.experience / (pet.level * 1000)) * 100}%` 
                }}
              />
            </div>

            <PetStats stats={pet.stats} />

            {pet.equippedItems.length > 0 && (
              <div className="pt-2 border-t border-gray-700">
                <div className="text-sm text-gray-400 mb-2">
                  Equipped Items: {pet.equippedItems.length}
                </div>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}